<template>
  <div class="row container-fluid">
    <div class="col-12">
      <PageHeader
        :title="$t('Checks')"
        :description="$t('From here you can control your Cheques reports')"
      />
    </div>
    <!-- تقارير الشيكات -->
    <reportsCard
      class="col-md-6"
      :cardTitle="$t('Cheques')"
      :icon="'fa-money-check-alt'"
      v-if="
        ($user.role.available_reports.find((el) => el.id == 27 || el.id == 28) || $user.admin) &&
        ($site.salesCheques_allow || $site.purchaseCheques_allow) &&
        ($user.admin || $user.role.sales_cheques_show || $user.role.purchase_cheques_show)
      "
      :reports="[
        {
          name: $t('Register Sales Cheques'),
          link: './chequesHistory',
          role: $user.role.available_reports.find((el) => el.id == 27) || $user.admin
        },
        {
          name: $t('CheckIn Record'),
          link: '/purchaseChequesHistory',
          role: $user.role.available_reports.find((el) => el.id == 28) || $user.admin
        }
      ]"
    />
  </div>
</template>
<script>
import reportsCard from '@/elements/reports/reportsCard.vue'
import PageHeader from '@/components/pageHeader'
export default {
  components: {
    reportsCard,
    PageHeader
  }
}
</script>
